module.exports = __webpack_public_path__ + "img/proList2_24.7080fd37.jpg";